import {
  IonButton,
  IonButtons,
  IonCard,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
  IonContent,
  IonItemDivider,
  IonInput,
} from "@ionic/react";
import { addCircleOutline, personCircleOutline } from "ionicons/icons";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import {
  clearCreateFilters,
  setPreselectAllPeople,
  setPreselectPeople,
  setRange,
} from "../../../store/MassNotification";
import { selectPeopleAvailable } from "../../../store/MassNotification/selectors/selectPeopleAvailable";
import { UsersSearchBar } from "./UsersSearchBar";
import { selectCreateFilters } from "../../../store/MassNotification/selectors/selectCreateFilters";
import { UsersSelectorLocationFilter } from "./UsersSelectorLocationFilter";

const avatarStyle = {
  verticalAlign: "middle",
};

export const PeopleSelector = () => {
  const dispatch = useDispatch();
  const people = useSelector(selectPeopleAvailable);
  const state = useSelector((state: RootState) => state.massNotification);
  const createFilters = useSelector(selectCreateFilters);

  const handleRangeChange = async (text: string) => {
    dispatch(setRange(text));
  };

  const handlePreselectAll = async () => {
    dispatch(setPreselectAllPeople(people));
  };

  return (
    <IonCard style={{ height: "75vh" }} class="ion-no-margin">
      <IonToolbar>
        <IonTitle size="small" style={{ fontWeight: 500 }}>
          Disponibles {people && <span>({people.length})</span>}{" "}
        </IonTitle>
        <IonButtons slot="end">
          {!!people.length && (
            <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectAll}>
              <small>Agregar todos</small>
              <IonIcon icon={addCircleOutline} slot="end" />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
      <UsersSearchBar />
      <IonCard color="transparent">
        <IonItemDivider>
          Filtros personalizados
          {createFilters.location.code && (
            <IonButtons slot="end">
              <IonButton color="danger" onClick={() => dispatch(clearCreateFilters())}>
                Limpiar filtros
              </IonButton>
            </IonButtons>
          )}
        </IonItemDivider>

        <section style={{ display: "flex", overflow: "auto", padding: 6 }}>
          <UsersSelectorLocationFilter />
        </section>
        {/* Seleccion de Rango de Location */}
        {createFilters.location.code && (
          <IonItem lines="none" className="ion-margin-bottom">
            <IonLabel position="stacked">Ingresa rango</IonLabel>
            <IonInput
              value={createFilters.range || ""}
              debounce={800}
              placeholder="Ej: 101-110, 121-131"
              onIonChange={({ detail: { value } }) => handleRangeChange(value!)}
            />
          </IonItem>
        )}
      </IonCard>
      <IonContent style={{ overflow: "scroll", height: "68vh" }}>
        <IonList>
          {state.findPeopleStatus === "succeeded" &&
            people.map((item) => (
              <IonItem key={item.id}>
                <IonLabel className="ion-hide-md-up" text-wrap>
                  <h5 style={{ fontWeight: 700 }}>
                    <IonIcon icon={personCircleOutline} style={avatarStyle}></IonIcon>{" "}
                    <IonText color="primary" style={avatarStyle}>
                      {item.name}
                    </IonText>
                  </h5>
                  <IonText color="medium" style={{ fontWeight: 400 }}>
                    <small>{item.role}</small>
                    <br />
                    <small>
                      {item.location.name} - {item.code}
                    </small>
                  </IonText>
                </IonLabel>
                <IonLabel className="ion-hide-md-down" text-wrap>
                  <h3 style={{ fontWeight: 700 }}>
                    <IonIcon icon={personCircleOutline} style={avatarStyle}></IonIcon>{" "}
                    <IonText color="primary" style={avatarStyle}>
                      {item.name}
                    </IonText>
                  </h3>
                  <IonText color="medium" style={{ fontWeight: 400 }}>
                    <small>{item.role}</small>
                    <br />
                    <small>
                      {item.location.name} - {item.code}
                    </small>
                  </IonText>
                </IonLabel>
                <IonButton
                  fill="clear"
                  onClick={() => {
                    dispatch(setPreselectPeople(item));
                  }}
                  size="default"
                >
                  <IonIcon icon={addCircleOutline} />
                </IonButton>
              </IonItem>
            ))}
          {state.findPeopleStatus === "pending" && (
            <p className="ion-text-center">
              <IonSpinner />
            </p>
          )}
        </IonList>
      </IonContent>
    </IonCard>
  );
};
